import React from "react";
import HubTabs from "../../components/HubTabs";
import Campaigns from "../Campaigns";
import ContactLists from "../ContactLists";
import { i18n } from "../../translate/i18n";

const tLang = (key, fallback) => {
  const v = i18n.t(key);
  return !v || v === key ? fallback : v;
};

const tabs = [
  {
    label: tLang("campaigns.subMenus.list", "Listagem"),
    path: "/campaigns",
    Component: Campaigns,
  },
  {
    label: tLang("campaigns.subMenus.listContacts", "Lista de contatos"),
    path: "/contact-lists",
    Component: ContactLists,
    match: "/contact-lists",
  },
];

const CampaignsHub = () => <HubTabs tabs={tabs} />;

export default CampaignsHub;
